import axios from "axios";
import _ from "lodash";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { AiOutlineClose } from "react-icons/ai";
import Swal from "sweetalert2";
import socket from "../../../../context/socket";
import { useDispatch, useSelector } from "react-redux";
import { fetchClientData } from "../../../../redux/client/clientSlice";
import YearSelect from "../../StartedYear/year";
import api from "../../../../utils/api";
import moment from "moment";

const GOAL_ID_EDUCATION = "66d028759a75443e96fd3412"; // your education goal id
const EDUCATION_OPTIONS = ["Graduation", "Post Graduation"];

const ChildrensEducationData = ({ children, roomId, card_id }) => {
  const lastChangedRef = useRef(null);
  const [selectedCard, setSelectedCard] = useState(null);
  const { clientData } = useSelector((state) => state.client);
  const dispatch = useDispatch();

  // derive current card
  const educationCard = useMemo(() => {
    const id = card_id || GOAL_ID_EDUCATION;
    return clientData?.dreamPoints?.find((g) => g._id === id) || null;
  }, [clientData, card_id]);

  const educationPriority = educationCard?.priority;

  // build initial state from client
  const [childrensEducationInputData, setChildrensEducationInputData] = useState({});

  useEffect(() => {
    if (!clientData || !children?.length) return;

    const initial = {};
    children.forEach((child) => {
      const goals =
        clientData?.dreamPoints?.flatMap((goal) =>
          (goal.action_data || []).filter((a) => a.childId === child._id)
        ) || [];

      const uniqueEdu = [
        ...new Set(
          goals
            .map((g) => g.maritalStatus)
            .filter((s) => EDUCATION_OPTIONS.includes(s))
        ),
      ];

      initial[child._id] = { education: uniqueEdu };
      EDUCATION_OPTIONS.forEach((status) => {
        const g = goals.find((x) => x.maritalStatus === status) || {};
        const idKey = `action_id_${status.replace(/\s/g, "_")}`;
        initial[child._id][`amount_${status}`] = String(g.amount ?? "");
        initial[child._id][`inflation_${status}`] = String(g.inflation ?? "");
        initial[child._id][`goalYear_${status}`] = String(g.goalYear ?? "");
        initial[child._id][`startYear_${status}`] = String(
          g.startYear ?? new Date().getFullYear()
        );
        initial[child._id][idKey] = g._id || "";
      });
    });

    setChildrensEducationInputData(initial);
  }, [children, clientData]);

  // keep selected card (socket data)
  useEffect(() => {
    if (!clientData || !card_id) return;
    setSelectedCard(clientData?.dreamPoints?.find((x) => x._id === card_id) || null);
  }, [clientData, card_id]);

  // socket join/leave + emit on data change (debounced emit)
  useEffect(() => {
    if (!roomId) return;
    socket.emit("join", roomId);
    return () => socket.emit("leave", roomId);
  }, [roomId]);

  const emitMessage = useMemo(
    () =>
      _.debounce((payload) => {
        socket.emit("message", payload);
      }, 300),
    []
  );

  useEffect(() => {
    emitMessage({
      room: roomId,
      data: { selectedCard, childrensEducationInputData },
    });
    return () => emitMessage.cancel();
  }, [selectedCard, roomId, childrensEducationInputData, emitMessage]);

  // ---- SAVE: triggered only onBlur ----
  const saveOne = async (childId, status) => {


    if (!status) return;
    const childObj = childrensEducationInputData?.[childId] || {};

    const amount = childObj[`amount_${status}`] || "0";
    const inflation = childObj[`inflation_${status}`] || "";
    const goalYear = childObj[`goalYear_${status}`] || "";
    const startYear =
      childObj[`startYear_${status}`] || String(new Date().getFullYear());

    // const isComplete =
    //   amount !== "0" &&
    //   String(inflation).length > 0 &&
    //   String(goalYear).length > 0 &&
    //   String(startYear).length > 0;


    const isComplete =
      amount !== "0" &&
      String(inflation).length > 0 &&
      String(goalYear).length > 0 &&
      String(startYear).length > 0;

      console.log('isComplete',isComplete);
      

      
    let goalText = ""
    if (childId) {

      const child = children.find(
        (c) => String(c._id) === String(childId)
      );
      if (child) {
        const ms = (status) ? status : "Graduation"
        goalText = child.name + "'s " + ms
      }
    }

    // ✅ previous saved record
    const prevActionData = educationCard?.action_data?.find(
      (a) =>
        String(a.childId) === String(childId) &&
        a.maritalStatus === status
    );

    const prevCreatedAt = educationCard?.created_at; // ROOT-level check

    // ❌ NO created_at inside action_data
    const actionDataItem = {
      maritalStatus: status,
      amount,
      inflation,
      goalYear,
      startYear,
      childId,
      goalText,
      status: isComplete ? 1 : 0,
    };




    const payload = {
      _id: roomId,
      dream_id: card_id || GOAL_ID_EDUCATION,
      action_data: [actionDataItem],
      status: 1,
      priority: educationPriority,
    };

    //  created_at (ONLY ONCE)
    if (isComplete && !prevCreatedAt) {
      payload.created_at = new Date().toISOString();
    }

    try {
      await api.post(
        `advisor/save_goal_tracker_data`,
        payload
      );
      // dispatch(fetchClientData(roomId));
    } catch (e) {
      console.error("Save error:", e);
    }
  };

  // state only (no save)
  const handleInputChange = (childId, field, value) => {
    lastChangedRef.current = { childId, field };
    setChildrensEducationInputData((prev) => ({
    ...prev,
    [childId]: { ...(prev?.[childId] || {}), [field]: value },
  }));
  };
  useEffect(() => {
  if (!lastChangedRef.current) return;
  const { childId, field } = lastChangedRef.current;
  handleBlurSave(childId, field);
}, [childrensEducationInputData]);

  // onBlur save for one field
  const handleBlurSave = (childId, field) => {
    // field ends with _Graduation or _Post Graduation
    const m = field.match(/_(Graduation|Post Graduation)$/);
    const status = m ? m[1] : null;
    if (status) saveOne(childId, status);
  };

  return (
    <>
      {children.map((child) => (
        <div key={child._id} className="mb-5">
          {console.log('ggg', child)
          }
          <div className="row ps-3">
            <div className="col-md-9 col-10">
              <p className="fs-21 lh-sm">
                <span className="clrgreen fw-semibold">{child.name}'s</span> Education <span className="clrgreen fw-semibold">{" "}({moment(child.dob).format("YYYY-MM-DD")}) </span>
              </p>
            </div>
          </div>

          <InputForm
            child={child}
            data={childrensEducationInputData}
            setChildrensEducationInputData={setChildrensEducationInputData}
            onChange={handleInputChange}
            onBlurSave={handleBlurSave}
            onSaveEducation={(childId, statusList) => {
              (statusList || []).forEach((s) => saveOne(childId, s));
            }}
            roomId={roomId}
            dispatch={dispatch}
          />
        </div>
      ))}
    </>
  );
};

const InputForm = ({
  child,
  data,
  setChildrensEducationInputData,
  onChange,
  onBlurSave,
  onSaveEducation,
  roomId,
  dispatch,
}) => {
  const selectedOptionsRaw = data?.[child._id]?.education || [];
  const selectedOptions = selectedOptionsRaw.length ? selectedOptionsRaw : [""];

  // --- put this inside InputForm ---
  const renameStatusKeys = (childData, fromStatus, toStatus) => {
    if (!fromStatus || !toStatus || fromStatus === toStatus) return childData;

    const mapKey = (k, s) => `${k}_${s}`;
    const oldIdKey = `action_id_${fromStatus.replace(/\s/g, "_")}`;
    const newIdKey = `action_id_${toStatus.replace(/\s/g, "_")}`;

    const next = { ...childData };

    // move 4 fields
    ["amount", "inflation", "goalYear", "startYear"].forEach((f) => {
      next[mapKey(f, toStatus)] = next[mapKey(f, fromStatus)] ?? "";
      delete next[mapKey(f, fromStatus)];
    });

    // move action_id
    next[newIdKey] = next[oldIdKey] ?? "";
    delete next[oldIdKey];

    // replace status in education array will be handled outside
    return next;
  };


  // Add option (keeps UI same)
  const handleAddOption = async () => {
    const current = data?.[child._id]?.education || [];
    const newOption = EDUCATION_OPTIONS.find((o) => !current.includes(o));

    if (newOption) {
      onChange(child._id, "education", [...current, newOption]);
      // save new education record only onBlur of its fields, or save skeleton now:
      await onSaveEducation(child._id, [newOption]);
      setTimeout(() => {
        dispatch(fetchClientData(roomId));
      }, 500);
    }
  };

  // // Change select (prevent duplicates), save onBlur (not on each change)
  // const handleSelectChange = (index, value) => {
  //   const current = data?.[child._id]?.education || [];
  //   const updated = [...current];
  //   updated[index] = value;
  //   const deduped = updated.filter(Boolean).filter((v, i, arr) => arr.indexOf(v) === i);
  //   onChange(child._id, "education", deduped);
  // };

  const saveStartYear = useMemo(
  () => _.debounce(onBlurSave, 300),
  [onBlurSave]
);

  const handleSelectChange = async (index, newStatus) => {
    const childData = data?.[child._id] || {};
    const current = childData.education || [];
    const oldStatus = current[index] || "";
    console.log('childData', childData, newStatus, oldStatus, data, child._id);

    // Ignore no-op
    if (!newStatus || newStatus === oldStatus) return;

    // Prevent duplicate (same status already somewhere else)
    if (current.includes(newStatus) && current.indexOf(newStatus) !== index) {
      Swal.fire({
        icon: "info",
        title: "Already selected",
        text: `"${newStatus}" is already added.`,
      });
      return;
    }

    // If oldStatus had an action_id, block change if mapped to folio
    if (oldStatus) {
      const oldIdKey = `action_id_${oldStatus.replace(/\s/g, "_")}`;
      const oldActionId = childData?.[oldIdKey] || "";

      if (oldActionId) {
        try {
          const existsRes = await api.post(
            `advisor/checkExistFolio`,
            {
              client_id: roomId,
              goal_id: "66d028759a75443e96fd3412", // your education goal id
              subgoal_id: oldActionId,
            }
          );

          if (existsRes.data === true) {
            // mapped → do not allow status change
            Swal.fire({
              icon: "warning",
              title: "Goal is mapped",
              text: "Please unmap the goal from folios before changing the education type.",
              confirmButtonText: "OK",
            });
            return;
          }

          // Not mapped → optional: remove old on server
          await api.post(
            `advisor/remove_eduction_goal`,
            {
              client_id: roomId,
              action_id: oldActionId,
              dream_point_id: "66d028759a75443e96fd3412",
              maritalStatus: oldStatus,
              childId: child._id,
              updateMS: 'delete'
            }
          );
        } catch (err) {
          console.error("Status change check/remove failed:", err);
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: "Could not change the education type right now.",
          });
          return;
        }
      }
    }

    // Local state update: rename keys + swap in education array
    setChildrensEducationInputData((prev) => {
      const prevChild = { ...(prev?.[child._id] || {}) };
      const renamed = renameStatusKeys(prevChild, oldStatus, newStatus);

      const nextEdu = [...(renamed.education || [])];
      nextEdu[index] = newStatus;
      // keep order, dedupe safety
      const deduped = nextEdu.filter(Boolean).filter((v, i, arr) => arr.indexOf(v) === i);

      return {
        ...prev,
        [child._id]: {
          ...renamed,
          education: deduped,
        },
      };
    });
    // refresh
    //  dispatch(fetchClientData(roomId));

    // Finally, save NEW status (skeleton or with values present)
    if (typeof onSaveEducation === "function") {
      onSaveEducation(child._id, [newStatus]);
    }
  };


  // Improved REMOVE flow
  const handleRemoveOption = async (index, childData) => {
    const currentEdu = childData?.education || [];
    const current = childData.education || [];
    const oldStatus = current[index] || "";

    const removedEducation = currentEdu[index]; // "Graduation" or "Post Graduation"
    if (!removedEducation) return;

    const idKey = `action_id_${removedEducation.replace(/\s/g, "_")}`;
    const action_id_to_check = childData?.[idKey] || "";

    try {
      // If mapped, block removal
      const existsRes = await api.post(
        `advisor/checkExistFolio`,
        {
          client_id: roomId,
          goal_id: GOAL_ID_EDUCATION,
          subgoal_id: action_id_to_check,
        }
      );

      if (existsRes.data === true) {
        Swal.fire({
          icon: "warning",
          title: "Goal is mapped",
          text: "Please unmap the goal from the folios before removing.",
          confirmButtonText: "OK",
          customClass: { confirmButton: "swal-confirm-btn" },
        });
        return;
      }

      const payload = {
        client_id: roomId,
        action_id: action_id_to_check,
        dream_point_id: GOAL_ID_EDUCATION,
        childId: child._id,
        maritalStatus: oldStatus
      }
      console.log('payload', index, childData);
      // Remove server-side (only if we have an action id)
      if (action_id_to_check) {
        await api.post(`advisor/remove_eduction_goal`, payload);
      }

      // Update local state for this child (clear removed fields)
      const updatedChildData = {
        ...childData,
        education: currentEdu.filter((_, i) => i !== index),
        [`amount_${removedEducation}`]: "",
        [`inflation_${removedEducation}`]: "",
        [`goalYear_${removedEducation}`]: "",
        [`startYear_${removedEducation}`]: "",
        [idKey]: "",
      };

      setChildrensEducationInputData((prev) => ({
        ...prev,
        [child._id]: updatedChildData,
      }));

      // refresh
      dispatch(fetchClientData(roomId));
    } catch (error) {
      console.error("Error removing education:", error);
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: "Something went wrong while removing the goal.",
      });
    }
  };

  return (
    <>
      {selectedOptions.map((selected, index) => (
        <div key={index}>
          <div className="row mt-3">
            <div className="col-md-1 col-2 heartwidth">
              <img src="assets/images/heart.png" alt="" />
            </div>
            <div className="col-md-9 col-8">
              <p className="fs-21 lh-sm">
                If I were to pay for <span className="clrgreen fw-semibold">{child.name}</span>
                <select
                  className="clrgreen fw-bold ps-3 moinput"
                  value={selected}
                  onChange={(e) => handleSelectChange(index, e.target.value)}
                  onBlur={(e) => {
                    const v = e.target.value;
                    if (v) onSaveEducation(child._id, [v]); // save skeleton on blur of select
                  }}
                  style={{ border: "none", borderBottom: "1px solid green", paddingLeft: "1rem" }}
                >
                  <option value="">Select</option>
                  {EDUCATION_OPTIONS
                    .filter((opt) => !selectedOptions.includes(opt) || opt === selected)
                    .map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                </select>{" "}
                today, I would require{" "}
                <span className="clrgreen fw-semibold">
                  {" "}
                  ₹{" "}
                  <input
                    type="number"
                    style={{
                      border: "none",
                      borderBottom: "1px solid green",
                      width: `${(data?.[child._id]?.[`amount_${selected}`]?.length || 0) + 3}ch`,
                      paddingLeft: "1rem",
                      minWidth: "4ch",
                    }}
                    className="clrgreen fw-bold ps-3 moinput"
                    value={data?.[child._id]?.[`amount_${selected}`] || ""}
                    onChange={(e) =>
                      onChange(child._id, `amount_${selected}`, e.target.value)
                    }
                    onBlur={() => onBlurSave(child._id, `amount_${selected}`)}
                    onKeyDown={(e) => {
                      if (e.key === "-" || e.key === "e") e.preventDefault();
                    }}
                    placeholder="0"
                  />
                </span>
                .
              </p>
            </div>
            <div className="col-md-2 col-2 text-end">
              {index > 0 && (
                <AiOutlineClose
                  style={{ cursor: "pointer", color: "red" }}
                  onClick={() => handleRemoveOption(index, data?.[child._id] || {})}
                />
              )}
            </div>
          </div>

          {/* Inflation */}
          <div className="row">
            <div className="col-md-1 col-2 heartwidth">
              <img src="assets/images/heart.png" alt="" />
            </div>
            <div className="col-md-8 col-10">
              <p className="fs-21 lh-sm">
                I expect these education costs to inflate at{" "}
                <input
                  type="number"
                  className="clrgreen fw-bold ps-3 moinput"
                  value={data?.[child._id]?.[`inflation_${selected}`] || ""}
                  onChange={(e) =>
                    onChange(child._id, `inflation_${selected}`, e.target.value)
                  }
                  onBlur={() => onBlurSave(child._id, `inflation_${selected}`)}
                  placeholder="0"
                  style={{
                    border: "none",
                    borderBottom: "1px solid green",
                    width: `${(data?.[child._id]?.[`inflation_${selected}`]?.length || 0) + 3}ch`,
                    paddingLeft: "1rem",
                    minWidth: "4ch",
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") e.preventDefault();
                  }}
                />{" "}
                % per year.
              </p>
            </div>
          </div>

          {/* Goal Year */}
          <div className="row">
            <div className="col-md-1 col-2 heartwidth">
              <img src="assets/images/heart.png" alt="" />
            </div>
            <div className="col-md-8 col-10">
              <p className="fs-21 lh-sm">
                My goal target is{" "}
                <input
                  type="number"
                  className="clrgreen fw-bold ps-3 moinput"
                  value={data?.[child._id]?.[`goalYear_${selected}`] || ""}
                  onChange={(e) =>
                    onChange(child._id, `goalYear_${selected}`, e.target.value)
                  }
                  onBlur={() => onBlurSave(child._id, `goalYear_${selected}`)}
                  placeholder="0"
                  style={{
                    border: "none",
                    borderBottom: "1px solid green",
                    width: `${(data?.[child._id]?.[`goalYear_${selected}`]?.length || 0) + 3}ch`,
                    paddingLeft: "1rem",
                    minWidth: "4ch",
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") e.preventDefault();
                  }}
                />
                .
              </p>
            </div>
          </div>

          {/* Start Year */}
          <div className="row">
            <div className="col-md-1 col-2 heartwidth">
              <img src="assets/images/heart.png" alt="" />
            </div>
            <div className="col-md-8 col-10 d-flex align-items-center">
              <p className="fs-21 lh-sm me-2 pt-3">Start Year</p>
              <div style={{ minWidth: "120px" }}>
                {/* <YearSelect
                  value={data?.[child._id]?.[`startYear_${selected}`] || ""}
                  onChange={(val) => onChange(child._id, `startYear_${selected}`, val)}
                  onBlur={() => onBlurSave(child._id, `startYear_${selected}`)}
                  recentYear={new Date().getFullYear()}
                /> */}
                <YearSelect
                  value={data?.[child._id]?.[`startYear_${selected}`] || ""}
                  onChange={(val) => {
                    onChange(child._id, `startYear_${selected}`, val);
                    onBlurSave(child._id, `startYear_${selected}`);
                  }}
                  recentYear={new Date().getFullYear()}
                />

              </div>
            </div>
          </div>
        </div>
      ))}

      {selectedOptionsRaw.length < EDUCATION_OPTIONS.length && (
        <button className="btn btn-success mt-2" onClick={handleAddOption}>
          Add More
        </button>
      )}
    </>
  );
};

export default ChildrensEducationData;
